<template>
  <div class="tab-plan authenticator-tab">
    <!-- 變更登入密碼／提款密碼（原在個人資料頁，不受 enable_google_totp 影響） -->
    <section class="security-setting-card">
      <div class="verify-form-title">
        {{ $t('Bao.setting_password') }}
      </div>
      <div class="security-action-block">
        <div class="security-action-heading">
          <div>
            <div class="security-subsection-title">
              {{ $t('Bao.login_password') }}
            </div>
            <p>{{ $t('Bao.login_password_desc') }}</p>
          </div>
        </div>
        <div class="security-action-footer">
          <p class="security-setting-note">
            {{ $t(`Bao.user_verify_password_${mode}`) }}
          </p>
          <button type="button" class="btn btn-stroke button-style btn-get-verify-code" @click="openVerifyPassword('login')">
            <span>{{ $t("Bao.user_verify_get_code") }}</span>
          </button>
        </div>
      </div>
      <div class="security-action-block">
        <div class="security-action-heading">
          <div>
            <div class="security-subsection-title">
              {{ $t('Bao.withdrawal_password') }}
            </div>
            <p>{{ $t('Bao.withdrawal_password_desc') }}</p>
          </div>
        </div>
        <div class="security-action-footer">
          <p class="security-setting-note">
            {{ $t(`Bao.user_verify_password_withdrawal_${mode}`) }}
          </p>
          <button type="button" class="btn btn-stroke button-style btn-get-withdrawal-verify-code" @click="openVerifyPassword('withdrawal')">
            <span>{{ $t("Bao.user_verify_get_code") }}</span>
          </button>
        </div>
      </div>
    </section>

    <section v-if="permissionInfo.enable_google_totp" class="security-setting-card security-authenticator-card">
      <div class="verify-form-title">
        {{ $t('Bao.auth_modal_text_1') }}
      </div>
      <p class="settings-info-description">
        {{ $t('Bao.auth_page_text_9') }}
      </p>
      <div class="authen-frame">
        <form class="row-frame dep-form-frame colu-12 form-row-gap ">
          <div class="colu colu-12">
            <div class="colu-10 switchTitle">
              {{ $t("Bao.auth_page_text_2") }}
            </div>
            <div class="colu-2 fields__item switchFrame">
              <input
                v-model="isChecked"
                type="checkbox"
                class="uiswitch"
                @click.prevent="getQrcodeAndUrl"
              >
            </div>
          </div>
          <div v-if="!google_auth_totp_status" class="colu colu-12">
            <label class="colu-12 authenTitle-babel" for="コードをAuthenticatorアプリにコピーして、パスワードを設定します。">
              {{ showQrCode ? $t("Bao.auth_page_text_10") : $t("Bao.auth_page_text_3") }}
            </label>
          </div>

          <!-- 未綁定 -->
          <template v-if="!google_auth_totp_status && showQrCode">
            <div class="colu colu-12">
              <div class="colu-12 inp-relative">
                <input id="コードをAuthenticatorアプリにコピーして、パスワードを設定します。" class=" for-input inpType" type="text" :value="qr_code_url">
                <button type="button" class="btn btn-keyChainCopy" @click="copyText(qr_code_url)" />
              </div>
            </div>

            <div class="colu-12">
              <div class="authenBox">
                <div class="authenQR">
                  <img
                    v-if="qr_code"
                    :src="'data:image/png;base64,' + qr_code"
                    alt="QR Code"
                    style="width: 150px;"
                  >
                </div>
                <div>
                  {{ $t("Bao.auth_page_text_5") }}
                  <a class="hyperlink t-highlight" :href="storeLink" target="_blank">{{ $t("Bao.auth_page_text_6") }}</a>
                </div>
              </div>
            </div>
            <div class="colu colu-12">
              <label class="colu-12 authenTitle-babel" for="Google Authenticatorアプリから6桁のコードを入力してください">
                {{ $t("Bao.auth_page_text_7") }}</label>
            </div>

            <div class="colu colu-12">
              <div class="colu-12 inp-relative">
                <input
                  id="Google Authenticatorアプリから6桁のコードを入力してください"
                  v-model="authenticatorCode"
                  class="colu-12 for-input inpType inp-float"
                  type="text"
                  :placeholder="$t('Bao.auth_modal_text_2')"
                >
                <div class="icon-inpInside icon-authen " />
              </div>
            </div>

            <div class="bank-promo-n form-submit-frame d-flex">
              <button
                :disabled="!authenticatorCode || authenticatorCode.length != 6 || actionLoading"
                type="button"
                class="btn btn-authen btn-tertiary btn-goToAuthen-popup btn-mb-w-100 flex-fill"
                @click="checkCode"
              >
                <span>{{ $t("Bao.auth_page_text_8") }}</span>
              </button>
            </div>
          </template>

          <!-- 已綁定但想解綁 -->
          <template v-if="google_auth_totp_status && wantToEnd && !isSuccess">
            <div class="colu colu-12">
              <label class="colu-12 authenTitle-babel" for="Google Authenticatorアプリから6桁のコードを入力してください">
                {{ $t("Bao.auth_page_text_7") }}</label>
            </div>

            <div class="colu colu-12">
              <div class="colu-12 inp-relative">
                <input
                  id="Google Authenticatorアプリから6桁のコードを入力してください"
                  v-model="authenticatorCode"
                  class="colu-12 for-input inpType inp-float"
                  type="text"
                  :placeholder="$t('Bao.auth_modal_text_2')"
                >
                <div class="icon-inpInside icon-authen " />
              </div>
            </div>

            <div class="bank-promo-n form-submit-frame d-flex">
              <button
                :disabled="!authenticatorCode || authenticatorCode.length != 6 || actionLoading"
                type="button"
                class="btn btn-authen btn-tertiary btn-goToAuthen-popup btn-mb-w-100 flex-fill"
                @click="checkCode"
              >
                <span>閉鎖</span>
              </button>
            </div>
          </template>
        </form>
      </div>
    </section>

    <!-- 密碼設定彈窗 -->
    <div v-if="showVerifyPassword" class="verify-code-wrap">
      <div class="popup-wrap verify-code-wrap" :class="{'active': showVerifyPassword}">
        <user-verify-code :type="passwordType" @close="showVerifyPassword = false" />
      </div>
    </div>
  </div>
</template>

<script>
import { getGoogleQrcode, updateGoogleStatus } from '@/api/user'
import { showNotice, copyText } from '@/utils/tool'
import { mapGetters } from 'vuex'
import userVerifyCode from '@/components/modal/userVerifyCode'

export default {
  components: {
    userVerifyCode
  },
  data() {
    return {
      isChecked: false,
      qr_code: null,
      qr_code_url: null,
      authenticatorCode: null,
      storeLink: this.getStoreLink(),
      actionLoading: false,
      isSuccess: false,
      showQrCode: false,
      wantToEnd: false,
      showVerifyPassword: false,
      passwordType: ''
    }
  },
  computed: {
    ...mapGetters(['user', 'permissionInfo', 'socialType']),
    mode() {
      // 是開啟信箱驗證,還是手機驗證
      return this.permissionInfo.email_need_verify ? 'email' : 'phone'
    },
    google_auth_totp_status() {
      return this.user.authStatus
    }
  },
  watch: {
    google_auth_totp_status(newValue) {
      this.isChecked = newValue
    }
  },
  mounted() {
    if (this.google_auth_totp_status) {
      this.isChecked = true
    } else {
      this.isChecked = false
    }
  },
  methods: {
    openVerifyPassword(type) {
      // 第三方登入的帳號不可變更登入密碼
      if (type === 'login' && this.socialType && this.socialType !== 'account') {
        showNotice(this.$t('Bao.password_cannot_change'))
        return
      }
      this.passwordType = type
      this.showVerifyPassword = true
    },
    getStoreLink() {
      const ua = navigator.userAgent.toLowerCase()
      if (ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1) {
        return 'https://apps.apple.com/app/google-authenticator/id388497605'
      } else if (ua.indexOf('android') > -1) {
        return 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2'
      }
      return 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2'
    },
    getQrcodeAndUrl() {
      if (!this.google_auth_totp_status && !this.isChecked) {
        this.showQrCode = true

        getGoogleQrcode().then(response => {
          if (response.data.data.code === 0) {
            this.qr_code = response.data.data.qr_code_url
            this.qr_code_url = response.data.data.secret
          } else {
            showNotice(response.data.msg)
          }
        }).catch((error) => {
          showNotice(error.response.data.msg)
        })
      } else if (this.google_auth_totp_status) {
        this.showQrCode = false
        this.isSuccess = false
        this.wantToEnd = true
      }
    },
    copyText(msg) {
      copyText(msg, this.qr_code_url)
    },
    checkCode() {
      this.actionLoading = true

      updateGoogleStatus({
        status: this.google_auth_totp_status ? 0 : 1, // 0關閉，1開啟
        opt_code: this.authenticatorCode
      }).then(response => {
        if (response.data.data.code === 0) {
          showNotice(this.$t('Bao.auth_result_text'))
          this.isSuccess = true
          this.authenticatorCode = null
          this.$store.commit('SET_GOOGLE_AUTH_STATUS', response.data.data.status)
        } else {
          showNotice(this.$t('Bao.auth_error_text'))
        }
      }).catch((error) => {
        showNotice(error.response.data.msg)
      }).finally(() => {
        this.actionLoading = false
      })
    }
  }
}
</script>
